import {
    AfterViewInit,
    ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone,
    OnDestroy, OnInit, Renderer2,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Component({
    selector: 'i360-loader',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, OnDestroy, AfterViewInit {
    size: number = 90;
    private onScrollSubscription = Subscription.EMPTY;
    private parentElement: HTMLElement;
    private loader: HTMLElement;

    constructor(
        private element: ElementRef,
        private zone: NgZone,
        private renderer: Renderer2,
        private detector: ChangeDetectorRef,
    ) {}

    get scrollContainer() {
        const cpanel66ScrollContainer = document.getElementById('contentContainer');
        if (cpanel66ScrollContainer) {
            return cpanel66ScrollContainer;
        }
        return window;
    }
    ngOnInit() {
        this.parentElement = this.element.nativeElement.parentElement;
        this.loader = this.element.nativeElement.querySelector('.big_loader');

        this.renderer.setStyle(this.parentElement, 'position', 'relative');
        if (this.parentElement.style.display === 'inline') {
            this.renderer.setStyle(this.parentElement, 'display', 'block');
        }

        this.calculateTopPosition();
        this.zone.runOutsideAngular(() => {
            this.onScrollSubscription = fromEvent(this.scrollContainer, 'scroll')
                .subscribe(() => this.calculateTopPosition());
        });
    }
    ngAfterViewInit() {
        this.detector.detach();
    }
    ngOnDestroy() {
        this.onScrollSubscription.unsubscribe();
    }
    calculateTopPosition() {
        let windowHeight: number = window.innerHeight;
        // place where we need jquery (possible solution - copy-paste implementation from jquery)
        let tableHeight: number = this.parentElement.offsetHeight;

        let scrollPosition: number = window.scrollY || document.documentElement!.scrollTop;
        let offset = this.parentElement.getBoundingClientRect();
        if (!offset) return;
        let topPosition: number = offset.top;

        let windowBottom: number = scrollPosition + windowHeight;
        let elementBottom: number = topPosition + tableHeight;
        let bottomDelta: number = (windowBottom > elementBottom) ? windowBottom - elementBottom : 0;

        let position;
        if (tableHeight > windowHeight) {
            if (scrollPosition < topPosition) {
                position = (
                    (windowHeight - topPosition + scrollPosition) / 2 - this.size / 2
                );
            } else {
                position = (
                    scrollPosition - topPosition + windowHeight / 2 - bottomDelta - this.size / 2
                );
            }
        } else {
            position = (tableHeight / 2 - this.size / 2);
        }
        this.renderer.setStyle(this.loader, 'top', `${position}px`);
    }
}
